<template>
  <div>
    <v-layout row class="pt-3">
      <v-flex xs4>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

  export default {
    name: 'General',
  };
</script>

<style scoped>

</style>
